import { useEffect, useState } from "react";
import {
  FaArrowRight,
  FaBlog,
  FaBuilding,
  FaCogs,
  FaHome,
  FaInfoCircle,
  FaLayerGroup,
  FaPaintBrush,
  FaPalette,
  FaProjectDiagram,
  FaRocket,
  FaSitemap,
  FaStar,
  FaTags,
  FaTimes,
} from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link, NavLink } from "react-router-dom";
import logo from "../img/Oglitz-main-icon.png";
import logoWhite from "../img/oglitzWithe.png";
import "./UpdatedNavbar.css";

import { FaChevronDown } from "react-icons/fa";

const UpdatedNavbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);
  const [mobileMoreOpen, setMobileMoreOpen] = useState(false);

  // SCROLL EFFECT
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const close = () => setMoreOpen(false);
    window.addEventListener("click", close);
    return () => window.removeEventListener("click", close);
  }, []);

  return (
    <>
      <header className={`oglitz-navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="oglitz-nav-inner">
          {/* LOGO */}
          <Link to="/" className="oglitz-logo">
            <img src={logo} alt="Oglitz Software" />
          </Link>

          {/* DESKTOP MENU */}
          <nav className="oglitz-nav-links">
            <NavLink to="/">Home</NavLink>
            <NavLink to="/about">About us</NavLink>
            <NavLink to="/services">Services</NavLink>
            <NavLink to="/project">Projects</NavLink>
            {/* <NavLink to="/plans-pricing">Plans & Pricing</NavLink> */}
            <div className="oglitz-more-wrapper">
              <button
                className="oglitz-nav-link oglitz-more-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  setMoreOpen(!moreOpen);
                }}
              >
                More
                <FaChevronDown
                  className={`caret ${moreOpen ? "rotate" : ""}`}
                />
              </button>

              {moreOpen && (
                <div className="oglitz-more-menu grid">
                  <NavLink to="/design" onClick={() => setMoreOpen(false)}>
                    <FaPaintBrush className="menu-icon" />
                    Design Pack
                  </NavLink>

                  <NavLink
                    to="/technologies"
                    onClick={() => setMoreOpen(false)}
                  >
                    <FaCogs className="menu-icon" />
                    Technologies
                  </NavLink>

                  <NavLink
                    to="/plans-pricing"
                    onClick={() => setMoreOpen(false)}
                  >
                    <FaTags className="menu-icon" />
                    Plans & Pricing
                  </NavLink>

                  <NavLink
                    to="/start-project"
                    onClick={() => setMoreOpen(false)}
                  >
                    <FaRocket className="menu-icon" />
                    Start Project
                  </NavLink>

                  <NavLink
                    to="/services-technologies"
                    onClick={() => setMoreOpen(false)}
                  >
                    <FaLayerGroup className="menu-icon" />
                    Services & Technologies
                  </NavLink>

                  <NavLink
                    to="/visit-software-hub"
                    onClick={() => setMoreOpen(false)}
                  >
                    <FaBuilding className="menu-icon" />
                    Company Profile
                  </NavLink>

                  <NavLink
                    to="/testimonials"
                    onClick={() => setMoreOpen(false)}
                  >
                    <FaStar className="menu-icon" />
                    Client Testimonials
                  </NavLink>

                  <NavLink to="/blogs" onClick={() => setMoreOpen(false)}>
                    <FaBlog className="menu-icon" />
                    Blogs
                  </NavLink>

                  <NavLink to="/sitemap" onClick={() => setMoreOpen(false)}>
                    <FaSitemap className="menu-icon" />
                    Sitemap
                  </NavLink>
                </div>
              )}
            </div>

            <NavLink to="/contact" className="oglitz-nav-cta">
              Contact Us
              <FaArrowRight />
            </NavLink>
          </nav>

          {/* MOBILE ICON */}
          <button className="oglitz-hamburger" onClick={() => setOpen(true)}>
            <GiHamburgerMenu />
          </button>
        </div>
      </header>

      {/* OVERLAY */}
      <div
        className={`oglitz-overlay ${open ? "show" : ""}`}
        onClick={() => setOpen(false)}
      />

      {/* MOBILE SIDEBAR */}
      <aside className={`oglitz-sidebar ${open ? "open" : ""}`}>
        <div className="sidebar-header">
          <img src={logoWhite} alt="Oglitz Software" />
          <button className="sidebar-close" onClick={() => setOpen(false)}>
            <FaTimes />
          </button>
        </div>

        {/* SCROLLABLE MENU */}
        <div className="sidebar-scroll">
          <NavLink to="/" onClick={() => setOpen(false)}>
            <FaHome />
            <span>Home</span>
          </NavLink>

          <NavLink to="/about" onClick={() => setOpen(false)}>
            <FaInfoCircle />
            <span>About Us</span>
          </NavLink>

          <NavLink to="/services" onClick={() => setOpen(false)}>
            <FaCogs />
            <span>Services</span>
          </NavLink>

          <NavLink to="/project" onClick={() => setOpen(false)}>
            <FaProjectDiagram />
            <span>Projects</span>
          </NavLink>

          <NavLink to="/design" onClick={() => setOpen(false)}>
            <FaPalette />
            <span>Design Pack</span>
          </NavLink>

          <NavLink to="/technologies" onClick={() => setOpen(false)}>
            <FaCogs />
            <span>Technologies</span>
          </NavLink>

          <NavLink to="/services-technologies" onClick={() => setOpen(false)}>
            <FaLayerGroup />
            <span>Services & Technologies</span>
          </NavLink>

          <NavLink to="/plans-pricing" onClick={() => setOpen(false)}>
            <FaTags />
            <span>Plans & Pricing</span>
          </NavLink>

          <NavLink to="/start-project" onClick={() => setOpen(false)}>
            <FaRocket />
            <span>Start Project</span>
          </NavLink>

          <NavLink to="/visit-software-hub" onClick={() => setOpen(false)}>
            <FaBuilding />
            <span>Company Profile</span>
          </NavLink>

          <NavLink to="/testimonials" onClick={() => setOpen(false)}>
            <FaStar />
            <span>Client Testimonials</span>
          </NavLink>

          <NavLink to="/blogs" onClick={() => setOpen(false)}>
            <FaBlog />
            <span>Blogs</span>
          </NavLink>

          <NavLink to="/sitemap" onClick={() => setOpen(false)}>
            <FaSitemap />
            <span>Sitemap</span>
          </NavLink>
        </div>

        {/* CTA FIXED AT BOTTOM */}
        <NavLink
          to="/contact"
          className="sidebar-cta-pill"
          onClick={() => setOpen(false)}
        >
          Contact Us <FaArrowRight />
        </NavLink>
      </aside>
    </>
  );
};

export default UpdatedNavbar;
